
<!-- "New version available" band above the nav bar; shown only once a new deploy is detected. -->
<app-update-strip></app-update-strip>
<app-nav-bar class="navbar navbar-expand-lg fixed-top navbar-nav-scrol bg-grey" [ngClass]="regulated ? '' : 'bg-green'"
  (onNavCollapse)="this.navCollapsed = !this.navCollapsed;" (onNavHeaderMobCollapse)="navMobClick()"></app-nav-bar>
  <app-sidebar class="sidebarview"></app-sidebar>
    <router-outlet></router-outlet>
    <app-footer></app-footer>
<app-configuration></app-configuration>
